// @ts-nocheck
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export enum HeaderStickyLevels {
    normal = "normal",
    sticky = "sticky",
    stickyingSmall = "stickyingSmall",
    stickySmall = "stickySmall",
}

export interface HeaderContextModel {
    headerLevel: HeaderStickyLevels;
    setHeaderLevel: (() => void) | Dispatch<SetStateAction<HeaderStickyLevels>>;
}

export const defaultContext: HeaderContextModel = {
    headerLevel: HeaderStickyLevels.normal,
    setHeaderLevel: () => {},
};

export const HeaderContext = createContext<HeaderContextModel>(defaultContext);

export const useHeaderContext = () => {
    const context = useContext(HeaderContext);

    if (!context) {
        throw new Error("Scroll Context is called outside a provider.");
    }

    return context;
};
